var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(false)?_c('hello-world'):_vm._e(),_c('alt-view'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }